import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useMutationApi, useQueryApi } from 'utils/api'

import type { UseMutationOptions } from 'react-query'
import type {
  TRequestKirimPenilaianTahunan,
  TRequestListPenilaianTahunan,
  TRequestOverridePenilaianTahunan,
  TRequestPayloadKirimPenilaianTahunan,
  TRequestPayloadOverridePenilaianTahunan,
  TRequestPenilaianTahunanCount,
  TRequestSummaryPenilaianTahunan,
  TResponseKirimPenilaianTahunan,
  TResponseListPenilaianTahunan,
  TResponseOverridePenilaianTahunan,
  TResponsePenilaianTahunanCount,
  TResponseSummaryPenilaianTahunan,
  UQO,
} from 'types/kinerja-dinas-penilaian'

export const API_GET_COUNT_PENILAIAN_TAHUNAN_DINAS =
  'API_GET_COUNT_PENILAIAN_TAHUNAN_DINAS'

export const API_GET_LIST_PENILAIAN_TAHUNAN_DINAS =
  'API_GET_LIST_PENILAIAN_TAHUNAN_DINAS'

export const API_GET_SUMMARY_PENILAIAN_TAHUNAN_DINAS =
  'API_GET_SUMMARY_PENILAIAN_TAHUNAN_DINAS'

export function useApiGetCountPenilaianTahunanDinas(
  params: TRequestPenilaianTahunanCount,
  opts?: UQO<TResponsePenilaianTahunanCount>
) {
  const skpYear = params?.year || undefined

  return useQueryApi<TResponsePenilaianTahunanCount>(
    `${apiPaths.penilaianTahunanDinas}/count`,
    {
      axiosConfig: { params: { skp_year: skpYear } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: [API_GET_COUNT_PENILAIAN_TAHUNAN_DINAS, skpYear],
    }
  )
}

export function useApiGetListPenilaianTahunanDinas(
  params: TRequestListPenilaianTahunan,
  opts?: UQO<TResponseListPenilaianTahunan>
) {
  const skpYear = params?.year || undefined
  const statusPengiriman = params?.statusPengiriman || undefined

  return useQueryApi<TResponseListPenilaianTahunan>(
    apiPaths.penilaianTahunanDinas,
    {
      axiosConfig: { params: { skp_year: skpYear, statusPengiriman } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: [
        API_GET_LIST_PENILAIAN_TAHUNAN_DINAS,
        skpYear,
        statusPengiriman,
      ],
    }
  )
}

export function useApiGetSummaryPenilaianTahunanDinas(
  params: TRequestSummaryPenilaianTahunan,
  opts?: UQO<TResponseSummaryPenilaianTahunan>
) {
  const skpYear = params?.year || undefined

  return useQueryApi<TResponseSummaryPenilaianTahunan>(
    `${apiPaths.penilaianTahunanDinas}/summary`,
    {
      axiosConfig: { params: { skp_year: skpYear } },
      queryConfig: { useErrorBoundary: false, ...opts },
      queryKey: [API_GET_SUMMARY_PENILAIAN_TAHUNAN_DINAS, skpYear],
    }
  )
}

export function useApiPatchOverridePenilaianTahunanDinas(
  params: TRequestOverridePenilaianTahunan,
  opts?: UseMutationOptions<
    TResponseOverridePenilaianTahunan,
    null,
    TRequestPayloadOverridePenilaianTahunan
  >
) {
  const skpYear = params?.year || undefined
  return useMutationApi(`${apiPaths.penilaianTahunanDinas}/override`, {
    axiosConfig: { params: { skp_year: skpYear }, method: 'PATCH' },
    mutationConfig: { useErrorBoundary: false, ...opts },
  })
}

export function useApiPostKirimPenilaianTahunanDinas(
  params: TRequestKirimPenilaianTahunan,
  opts?: UseMutationOptions<
    TResponseKirimPenilaianTahunan,
    null,
    TRequestPayloadKirimPenilaianTahunan
  >
) {
  const skpYear = params?.year || undefined
  return useMutationApi(apiPaths.penilaianTahunanDinas, {
    axiosConfig: { params: { skp_year: skpYear }, method: 'POST' },
    mutationConfig: { useErrorBoundary: false, ...opts },
  })
}
